import { reactive } from 'vue';

export const useWindowSize = (handler: () => void) => {

    const windowSize = reactive({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const onResize = () => {
        windowSize.width = window.innerWidth;
        windowSize.height = window.innerHeight;
        handler();
    };

    window.addEventListener('resize', onResize);

    return windowSize;
};